module.exports = __webpack_public_path__ + "img/fuli.d7137a45.png";